import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {StateViewComponent} from "./stateview.component";
import {StateInfoItemRendererFactory} from "./stateinfoitemrendererfactory";
import {WebmateBrowserModule} from "../browser/webmate-browser.module";
import {StateComparisonComponent} from "./statecomparison.component";
import {CanvasModule} from "../canvas/canvas.module";
import {StateSummaryComponent} from "./statesummary.component";
import {StatePropertyMismatchComponent} from "./state-property-mismatch.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {TooltipModule} from "primeng/tooltip";
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {PopoverModule} from 'primeng/popover';
import {ButtonModule} from 'primeng/button';
import {StateCollectionComponent} from "@webmate-web-core/shared/components/state/statecollection.component";
import {StateInfoComponent} from "@webmate-web-core/shared/components/state/stateinfo.component";
import {FactsModule} from "@webmate-web-core/shared/components/facts/facts.module";
import {ResourceViewsModule} from "@webmate-web-core/shared/components/resources/resource-views.module";
import {ScreenshotModule} from "@webmate-web-core/shared/components/screenshot/screenshot.module";
import {TagsModule} from "@webmate-web-core/shared/components/tags/tags.module";
import {WmDateFormatPipe} from "@webmate-web-core/shared/utils/pipes/wm-date-format.pipe";
import {ClippingWindowComponent} from "@webmate-web-core/misc/clipping-window/clipping-window.component";

@NgModule({
    declarations: [
        StateCollectionComponent,
        StateInfoComponent,
        StateComparisonComponent,
        StateViewComponent,
        StateSummaryComponent,
        StatePropertyMismatchComponent
    ],
    providers: [
        StateInfoItemRendererFactory
    ],
	imports: [
		CommonModule,
		WebmateBrowserModule,
		CanvasModule,
		FontAwesomeModule,
		TooltipModule,
		ProgressSpinnerModule,
		PopoverModule,
		ButtonModule,
		FactsModule,
		ResourceViewsModule,
		ScreenshotModule,
		TagsModule,
		WmDateFormatPipe,
		ClippingWindowComponent,
	],
    exports: [
        StateCollectionComponent,
        StateComparisonComponent,
        StateInfoComponent,
        StateViewComponent,
        StateSummaryComponent,
        StatePropertyMismatchComponent
    ]
})
export class StateModule {}
